export default __webpack_public_path__ + "static/media/hoteles.3e2707fc.jpg";